module.exports = "/images/arrow-down.svg?f5022f201634f9c824b92f954079dc8d";